export default "/images/vendor/flag-icon-css/flags/1x1/kg.svg?3aa9ef95cc4630428b294d8b53e02973";